import {
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ar_EG, en_US, NzI18nService } from 'ng-zorro-antd/i18n';
import { InitApprovalServiceSteps } from './apeco-services/shared/fom-config/inital-approval-form.config';
import { map, startWith, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly translateService = inject(TranslateService);
  private readonly i18n = inject(NzI18nService);
  title = 'Apeco-Fe';
  textDir = 'ltr';
  serviceData = InitApprovalServiceSteps;
  activeRoute = inject(ActivatedRoute);
  sub = new Subscription();

  ngOnInit(): void {
    this.handelLanguageChange();
  }

  private handelLanguageChange() {
    let storedLang = localStorage.getItem('lang');

    this.sub.add(
      this.activeRoute.queryParams.subscribe((param) => {
        if (param['lang']) {
          storedLang = param['lang'];
          localStorage.setItem('lang', storedLang ?? 'en');
        }

        if (storedLang) {
          this.textDir = storedLang.toString() === 'en' ? 'ltr' : 'rtl';
          this.translateService.setDefaultLang(storedLang);
          this.i18n.setLocale(storedLang === 'en' ? en_US : ar_EG);
        } else {
          this.textDir = 'ltr';
          localStorage.setItem('lang', 'en');
          this.translateService.setDefaultLang('en');
          this.translateService.use('en');
        }
      })
    );

    this.sub.add(
      this.translateService.onLangChange
        .pipe(
          map((res) => res.lang),
          startWith(storedLang)
        )
        .subscribe((lang) => {
          this.textDir = lang === 'en' ? 'ltr' : 'rtl';
          this.i18n.setLocale(lang === 'en' ? en_US : ar_EG);
          this.cdr.detectChanges();
        })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
